import React from "react";
import ReactDOM from "react-dom";
import {LargeGrantAwardees} from "../components/LargeGrantAwardees";

export const insertLargeGrantAwardees = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="large-grant-awardees"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<LargeGrantAwardees />, element);
  });
};
